export default "__VITE_ASSET__DoweaQcK__"